module.exports = __webpack_public_path__ + "img/icon-side-arrow.85bf5795.svg";